import { createSlice } from "@reduxjs/toolkit";
import { InitialLeafStockFormData } from "../../ConstantData/InitialData";
import { InitialLeafStockDuplicateFormData } from "../../ConstantData/InitialDuplicateData";
const leafStockSlice = createSlice({
  name: "leafstock",
  initialState: {
    leafStockList: [],
    dataEdit: {},
    errorData: {},
    isError: false,
    billList: [],
    // billDataList: {},
    initialData: InitialLeafStockFormData,
    // initialDuplicateData: InitialLeafStockDuplicateFormData,
  },
  reducers: {
    getAllLeafStocks: (state, action) => {
      state.leafStockList = action.payload;
    },
    getLeafStockDataEdit: (state, action) => {
      state.dataEdit = action.payload;
    },
    setErrorData: (state, action) => {
      state.errorData = action.payload.message;
      state.isError = action.payload.isError;
    },
    setInitialData: (state) => {
      state.initialData = { ...InitialLeafStockFormData };
    },
    // setDuplicateInitialData: (state) => {
    //   state.initialDuplicateData = { ...InitialLeafStockDuplicateFormData };
    // },
    getBillList: (state, action) => {
      if (action.payload.data.length <= 0) {
        state.initialDuplicateData = [];
      }
      state.billList = action.payload.data;
    },
    getDataUsingBill: (state, action) => {
      state.initialDuplicateData = action.payload.data;
      state.dataEdit = action.payload.editData;
    },
    adjustLeafStockItem: (state, action) => {},
    deleteLeafStock: () => {},
  },
});

export const leafStockSliceAction = leafStockSlice.actions;
export default leafStockSlice.reducer;
